/* eslint-disable camelcase */
export interface BackendProps {
    redirectUrl: string;
    formHiddenFields: LoginRegisterFormHiddenFields;
    isMultiStep: boolean;
    isReferral?: boolean;
    forgetPasswordRedirectUrl?: string;
}

export interface MultiStepRegistrationFormProps {
    activeStep: number;
    setActiveStep: Function;
    isLastStep: boolean;
    setIsLastStep: Function;
    privacyPolicy: string;
}

export interface LoginRegisterFormProps extends BackendProps {
    apiBaseUrl: string;
    showLogin: boolean;
    isMagicLinkEnabled?: boolean;
    handleShowLoginToggle: () => void;
    mailcheckOptions?: Partial<MailcheckModule.ISynchronousOptions>;
    formIdentifiers?: LoginRegisterFormIdentifiers;
    animatedSubmitButtonCta?: boolean;
    animateEmailPlaceholder?: boolean;
    defaultEmail: string;
    setIsFormReady?: Function;
    isFormReady: boolean;
    focusSignupFormEmail?: boolean;
    isSignupFormFolded: boolean;
    setIsSignupFormFolded: Function;
    handleClose: () => void;
}

export interface CommonFormProps
    extends Omit<
        LoginRegisterFormProps,
        | 'setIsFormReady'
        | 'showLogin'
        | 'mailcheckOptions'
        | 'isMultiStep'
        | 'isOpen'
        | 'emailPlaceholderAnimStartDelay'
        | 'defaultEmail'
        | 'isFormReady'
        | 'isSignupFormFolded'
        | 'setIsSignupFormFolded'
    > {
    inputEmail: string;
    handleEmailChange: Function;
}

export interface LoginFormProps extends CommonFormProps {
    formName?: string;
    isLoading: boolean;
    setIsLoading: Function;
    backendEmailValidator: Function;
    isMagicLinkEnabled?: boolean;
    defaultEmail: string;
    forgetPasswordRedirectUrl?: string;
    hideSwitch: boolean;
}

export interface SignupFormProps
    extends CommonFormProps,
        Pick<
            LoginRegisterFormProps,
            'mailcheckOptions' | 'isMultiStep' | 'isReferral' | 'focusSignupFormEmail' | 'isFormReady'
        >,
        MultiStepRegistrationFormProps {
    formName?: string;
    isLoading: boolean;
    setIsLoading: Function;
    isFolded: boolean;
    setIsFolded: Function;
    animatedSubmitButtonCta?: boolean;
    animateEmailPlaceholder?: boolean;
    backendEmailValidator: Function;
    hideSwitch: boolean;
    formType?: FORM_TYPES;
}

export interface LoginRegisterFormHiddenFields {
    formType: FormField;
    pageType?: FormField;
}

export interface LoginRegisterFormIdentifiers {
    form: {
        login: string;
        signup: string;
    };
    email: string;
    password: string;
    submit: string;
}

interface FormField {
    name: string;
    value: string;
}
export enum FORM_TYPES {
    SHARED_SIGNUP_FORM = 'SHARED_SIGNUP_FORM',
    SIMPLE = 'SIMPLE',
}

// TODO Move to API types.
export interface LoginFormValues extends ClubApiValues {
    email: string;
    password: string;
    formType?: FORM_TYPES;
}

export interface SignupFormValues extends LoginFormValues {
    agb: string;
    subscribe?: string;
}

export interface ClubApiValues {
    reg_form_type?: string;
    redirectUrl?: string;
    YII_CSRF_TOKEN?: string;
}
